"use client";

import Image from "next/image";
import { useEffect, useRef, useState } from "react";
import UnicornScene from "unicornstudio-react/next";

const IMG_QUOTE_BG = "/images/homepage/quote-bg.png";

export function QuoteBackground() {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
  const [hasError, setHasError] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    setPrefersReducedMotion(mq.matches);
    const handler = (e: MediaQueryListEvent) => setPrefersReducedMotion(e.matches);
    mq.addEventListener("change", handler);
    return () => mq.removeEventListener("change", handler);
  }, []);

  useEffect(() => {
    const el = ref.current;
    if (!el || prefersReducedMotion) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          observer.disconnect();
        }
      },
      { rootMargin: "200px" },
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [prefersReducedMotion]);

  return (
    <div ref={ref} className="pointer-events-none absolute inset-0" aria-hidden="true">
      {visible && !prefersReducedMotion && !hasError ? (
        <UnicornScene
          projectId="FojzbSuBEKszdwrdUU73"
          scale={1}
          dpi={1.5}
          fps={30}
          production
          className="h-full w-full"
          onError={e => {
            console.error("[QuoteBackground] Unicorn scene failed", e);
            setHasError(true);
          }}
        />
      ) : (
        <Image alt="Testimonial background pattern" src={IMG_QUOTE_BG} fill sizes="100vw" className="object-cover" />
      )}
    </div>
  );
}
